import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-3" }
const _hoisted_2 = { class: "_flexcol _gap-3" }
const _hoisted_3 = { class: "gfu-richtext" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_collapsible = _resolveComponent("base-collapsible")
  const _component_base_notificator = _resolveComponent("base-notificator")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.notifications, (notificator) => {
      return (_openBlock(), _createBlock(_component_base_notificator, {
        key: notificator.orderCommunicationID,
        type: "warning",
        onClose: $event => ($options.onExtraChargeNotificatorClose(notificator.orderCommunicationID))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.YourPledge.YourPledgeExtraChargeDescription
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  "format-key": "0",
                  class: "_tdu",
                  onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onRequestRefundClick && $options.onRequestRefundClick(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.Resources.YourPledge.YourPledgeExtraChargeRequestRefundLabel), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"]),
            _createVNode(_component_base_collapsible, {
              "is-expanded": notificator.isExpanded,
              rounded: false,
              "data-qa-value": `${notificator.orderCommunicationID}`,
              onToggle: $options.onToggleCollapsible,
              "data-qa": "your-pledge:ExtraChargeCreatorMessage"
            }, {
              trigger: _withCtx(({ isExpanded }) => [
                _createVNode(_component_base_icon, {
                  name: isExpanded ? 'chevron-up' : 'chevron-down'
                }, null, 8 /* PROPS */, ["name"]),
                (!isExpanded)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.YourPledgeExtraChargeShowCreatorMessageLabel), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.YourPledgeExtraChargeHideCreatorMessageLabel), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", {
                    innerHTML: notificator.text
                  }, null, 8 /* PROPS */, _hoisted_4)
                ])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-expanded", "data-qa-value", "onToggle"])
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClose"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}